/*
 * Declare Search Helper Container.
 */
var SH = SH || {};

/*
 * Anonymus init function.
 */
(function ($) {

    /*
     * Needs to be set by the search implementation:
     * - SH.settings.form
     * - SH.settings.formPage
     * - SH.settings.nodeResults
     * - SH.getSearchUrl
     */

    /*
     * Get query string parameter.
     */
    SH.getParameterByName = function (name, url) {
        if (!url) {
            url = window.location.href;
        }

        name = name.replace(/[\[\]]/g, "\\$&");

        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);

        if (!results) {
            return null;
        }

        if (!results[2]) {
            return '';
        }

        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    /*
     * Display search loading.
     */
    SH.displayLoading = function () {
        $('.main--overlay').show();
        $('.loader-container').show();
    }

    /*
     * Hide search loading.
     */
    SH.hideLoading = function () {
        $('.main--overlay').hide();
        $('.loader-container').hide();
    }

    /*
     * Process the search results.
     */
    SH.onSearchSubmit = function () {
        SH.displayLoading();
    }

    /*
     * Get distance in KM or Miles.
     */
    SH.translateDistance = function (distanceInMeters, region) {
        var distance = '';
        var unit = 'KM';

        if ('us' === region) {
            // Use Imperial (miles)
            distance = (distanceInMeters * 0.00062137).toFixed(2);
            unit = 'mi';
        } else {
            // Convert to KM
            distance = (distanceInMeters / 1000).toFixed(2);
        }

        return {
            'distance': distance,
            'unit': unit
        };
    }

})(jQuery);
